import { VF_BUTTON_SELECTOR } from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  selectNetworkParamsIdRequester,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-one/section-one-constants';

const fieldId = selectNetworkParamsIdRequester;

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;


  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();
  const fieldsValue = values && values[fieldId] ? values[fieldId] : [];

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(fieldsValue, VF_BUTTON_SELECTOR);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an option' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const initialValues = [];

const vFParams = {
  multiSelect: false,
  displayType: 'big',
  fieldTitle: 'Select network',
};

const selectNetworkParamsRequester = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_BUTTON_SELECTOR,
};

export { selectNetworkParamsRequester };
